import { gql } from 'apollo-boost';

export const SEND_SLACK_NOTIFICATION = gql`
  mutation ($message: String!) {
    sendSlackNotification(message: $message)
  }
`;
